import React from "react";

const Logo = ({ className = "" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mr-2"
      >
        {/* Sun rays */}
        <path
          d="M20 4V8M20 32V36M8 20H4M36 20H32M10.343 10.343L7.515 7.515M32.485 32.485L29.657 29.657M10.343 29.657L7.515 32.485M32.485 7.515L29.657 10.343"
          stroke="#FF6B6B"
          strokeWidth="2"
          strokeLinecap="round"
        />
        {/* Sun circle with gradient */}
        <defs>
          <linearGradient id="sunGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FF6B6B" />
            <stop offset="100%" stopColor="#FF8E53" />
          </linearGradient>
        </defs>
        <circle cx="20" cy="20" r="8" fill="url(#sunGradient)" />
        {/* Cloud with gradient */}
        <defs>
          <linearGradient
            id="cloudGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#E2E8F0" />
            <stop offset="100%" stopColor="#F8FAFC" />
          </linearGradient>
        </defs>
        <path
          d="M28 24C30.2091 24 32 22.2091 32 20C32 17.7909 30.2091 16 28 16C27.7288 16 27.4663 16.0201 27.2149 16.0584C26.409 14.2673 24.8645 13 23 13C20.7909 13 19 14.7909 19 17C19 17.3416 19.0344 17.6758 19.1 18C17.3431 18 16 19.3431 16 21C16 22.6569 17.3431 24 19 24H28Z"
          fill="url(#cloudGradient)"
        />
      </svg>
      <div className="flex flex-col">
        <div className="flex items-center">
          <span className="text-xl font-bold bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] bg-clip-text text-transparent">
            Sama
          </span>
          <span className="ml-2 text-xs text-gray-400 italic hidden sm:block">
            (sky in arabic)
          </span>
        </div>

        <span className="text-xs text-gray-500 hidden sm:block">
          Made with ❤️ by{" "}
          <a href="https://github.com/ramialkaro" className="text-blue-500">
            Rami Al-Karo
          </a>
        </span>
      </div>
    </div>
  );
};

export default Logo;
